import {createGlobalStyle, withTheme} from "styled-components"
import {media} from "utils/Media"
import fontFiles from "./Fonts";

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'MontserratLight';
    src: url("${fontFiles.MontserratLight}") format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'MontserratRegular';
    src: url("${fontFiles.MontserratRegular}") format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'MontserratBold';
    src: url("${fontFiles.MontserratBold}") format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'ProximaNovaW01Regular';
    src: url("${fontFiles.ProximaNovaW01RegularWOFF2}") format('woff2'),
    url("${fontFiles.ProximaNovaW01RegularWOFF}") format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'ProximaNovaW01Bold';
    src: url("${fontFiles.ProximaNovaW01BoldWOFF2}") format('woff2'),
    url("${fontFiles.ProximaNovaW01BoldWOFF}") format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  html, body {
    max-width: 100%;
    overflow-x: hidden;
  }

  body {
    font-family: ${props => props.theme.font.family.body};
    font-size: ${props => props.theme.font.size.base};
    line-height: ${props => props.theme.font.lineHeight.base};
    color: ${props => props.theme.colors.black};
    background-color: ${props => props.theme.colors.white};
    -webkit-font-smoothing: antialiased;
    overflow-x: hidden;
      /* transition: ${props => props.theme.transitionBase}; */

    &.nav-active {
      overflow: hidden;
    }

    &.dropdown-filter-active {
      overflow: hidden;

      @media ${media.lg} {
        overflow: visible;
      }

      main {
        position: relative;
        z-index: 1100;

        @media ${media.lg} {
          z-index: 1;
        }
      }
    }
  }

  body:not(.user-is-tabbing) button:focus,
  body:not(.user-is-tabbing) input:focus,
  body:not(.user-is-tabbing) select:focus,
  body:not(.user-is-tabbing) textarea:focus,
  body:not(.user-is-tabbing) div[role="button"]:focus {
    outline: none;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${props => props.theme.colors.black};
    font-family: ${props => props.theme.font.family.black};
    line-height: ${props => props.theme.font.lineHeight.headings};
    margin-bottom: 1rem;
    font-weight: 700;
  }

  h1 {
    font-size: ${props => props.theme.font.h3.size};
    @media ${media.sm} {
      font-size: ${props => props.theme.font.h2.size};
    }
    @media ${media.md} {
      font-size: ${props => props.theme.font.h1.size};
    }
  }

  h2 {
    font-size: ${props => props.theme.font.h4.size};
    @media ${media.sm} {
      font-size: ${props => props.theme.font.h3.size};
    }
    @media ${media.md} {
      font-size: ${props => props.theme.font.h2.size};
    }
  }

  h3 {
    font-size: ${props => props.theme.font.h4.size};
    @media ${media.md} {
      font-size: ${props => props.theme.font.h3.size};
    }
  }

  h4 {
    font-size: ${props => props.theme.font.h4.size};
  }

  h5 {
    font-size: ${props => props.theme.font.h5.size};
  }

  h6 {
    font-size: ${props => props.theme.font.h6.size};
  }

  p {
    font-family: ${props => props.theme.font.family.body};

    &:last-child {
      margin: 0;
    }
  }

  strong {
    font-family: ${props => props.theme.font.family.black};
  }

  a {
    color: ${props => props.theme.colors.midBlue};
    transition: color .4s ease;
    text-decoration: underline solid ${props => props.theme.colors.midBlue} 2px;
    font-weight: ${props => props.theme.font.weight.bold};

    &:hover {
      color: ${props => props.theme.colors.midBlue};
      text-decoration: underline solid ${props => props.theme.colors.midBlue} 2px;
    }
  }

  strong {
    font-weight: ${props => props.theme.font.weight.bold};
  }

  ul {
    padding-left: 20px;
  }

  img {
    max-width: 100%;
  }

  hr {
    border-color: ${props => props.theme.colors.quaternary};
    border-style: solid;
    margin: 1.5rem 0;
  }

  .modal-backdrop.show {
    opacity: 0.9;
      /* background-color: ${props => props.theme.colors.primary}; */
  }

  .modal-content {
    border-radius: 0;

    @media ${media.md} {
      padding: 1rem;
    }
    @media ${media.lg} {
      padding: 2rem;
    }
  }

  .d-xxl-block {
    @media ${media.xxl} {
      display: block !important;
    }
  }

  .d-xxl-none {
    @media ${media.xxl} {
      display: none !important;
    }
  }

  .bkg-primary {
    background-color: ${props => props.theme.colors.primary};
    @media ${media.md} {
      background: transparent;
    }
  }

  .LazyLoad, .lazyload-wrapper {
    width: 100%;
  }

  /* light gallery */
  .lg-backdrop {
    background-color: ${props => props.theme.colors.primary};

    &.in {
      opacity: .9;
    }
  }

  .baseTitle {
    text-align: center;
    font-family: ${props => props.theme.font.family.heading};
    text-transform: uppercase;
    //font-style: italic;
    font-size: ${props => props.theme.font.size.xl};
  }

  .baseText {
    font-family: ${props => props.theme.font.family.base};
    font-weight: ${props => props.theme.font.weight.regular};
  }

  .lg-toolbar {
    background-color: rgba(0, 0, 0, 1);
  }

  .lg-outer {
    direction: ltr; /* rtl for AR break it */
  }

  .background-gradient {
    &::after {

      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: ${props => props.theme.colors.gradientLeft};
      content: '';
    }
  }

  .formMessage {
    p {
      color: #fff !important;
      font-family: ${props => props.theme.font.family.heading};
    }
  }

  .input-placeholder {
    &::placeholder {
      color: black !important;
    }
  }

  .modal-backdrop {
    background-color: #000;

    &.bd-white {
      background-color: #fff;
    }
  }

  .hero-padding {
    @media ${media.md} {
      padding-left: 75px;

    }
    @media ${media.xl} {
      padding-left: 85px;
    }
  }
  
  .submit-button {
      width: 180px;
      background: ${(props) => props.theme.colors.tertiary};
      border: ${(props) => props.theme.colors.secondary} solid 2px;
      padding: 0.25rem 0.5rem;

      span {
        color: #fff;
        font-family: ${(props) => props.theme.font.family.bold};
        //font-style: italic;
        font-size: 1.25rem;
        text-transform: uppercase;
      }

    @media ${media.md} {
      width: 220px;
      padding: 0.75rem 0.5rem;
    }
  }
`;

export default withTheme(GlobalStyles);